import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../style/choose-dialog.css';

const vals = ['States', 'Capitals'];

const ChooseDialog = ({ dispatch }) => (
  <div className="choose-dialog">
    {
      vals.map(v => (
        <button
          key={v}
          id={v}
          onClick={() => dispatch({ type: 'CHOOSE', payload: { id: v } })}
        >
          {v}
        </button>
      ))
    }
  </div>
);

ChooseDialog.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

export default connect()(ChooseDialog);



// WEBPACK FOOTER //
// ./src/components/ChooseDialog.js